import Folder from '../Folder'
import _ from 'lodash'

export default {
  name: 'folderSet',
  props: ['item', 'scan_list', 'show', 'press', 'only_view', 'is_refresh', 'disk_list', 'white_path', 'white_file', 'scan_list_history', 'white_file_active', 'os_type'],
  components: { Folder },
  data: function () { return {
    modal_scan_list_history : false,
    dragged : undefined,
    lock : false,
    input_custom_1 : '',
    input_custom_2 : '',
    hide_docker_overlay : true,
    show_permission : false,
  } },
  computed: {
    folder_max_len() { return _.sum(_.map(this.disk_list, x => x.mountpoint.length)) / this.disk_list.length / 2 }
  },
  methods: {
    add_white_list_custom() {
      console.log("add", this.input_custom_1)
      // valid exists startwith

      if(!this.scan_list.length) {
        return this.$toastr.w('warning', 'no have monitoring folder')
      }

      if(_.filter(this.white_path, x => x == this.input_custom_1).length > 0) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w("duplicate")
      }

      // console.log(_.filter(this.scan_list, x => !_.startsWith(x, this.input_custom_1) == false))
      if(_.filter(this.scan_list, x => _.startsWith(this.input_custom_1, x)).length < 1 ) {
      // if(_.filter(this.scan_list, x => !_.startsWith(x, this.input_custom_1) == false).length > 0) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w('warning', 'Monitoring folder not included #path')
      }


      this.$parent.$emit("add_white_list", { abs_path : this.input_custom_1, name : this.input_custom_1 })

      this.input_custom_1 = ''
    },
    add_white_file_custom() {
      console.log("add", this.input_custom_2)
      // valid exists startwith

      if(!this.scan_list.length) {
        return this.$toastr.w('warning', 'no have monitoring folder')
      }

      if(_.filter(this.white_file, x => x == this.input_custom_2).length > 0) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w("duplicate")
      }

      // console.log(_.filter(this.scan_list, x => !_.startsWith(x, this.input_custom_2) == false))
      if(_.filter(this.scan_list, x => _.startsWith(this.input_custom_2, x)).length < 1 ) {
        // 해당 경로는 넣을 수 없음
        return this.$toastr.w('warning', 'Monitoring folder not included #file')
      }

      this.$parent.$emit("add_white_list_file", { abs_path : this.input_custom_2, name : this.input_custom_2 })

      this.input_custom_2 = ''
    },
    ondrag() {},
    drag() {},
    dragstart(event, item) {
      if(this.lock) { return console.log('already lock') }

      this.lock = true
      // 드래그한 요소에 대한 참조 변수
      this.dragged = item;
      // 요소를 반투명하게 함
      event.target.style.opacity = .4;
    },
    dragend(event) { event.target.style.opacity = ""; },
    dragover(event) { event.preventDefault(); },
    dragenter(event) {
      if (_.startsWith(event.target.className, 'dropzone_path')) { event.target.style.background = "gainsboro"; }
    },
    dragleave(event) {
      if (_.startsWith(event.target.className, 'dropzone_path')) { event.target.style.background = ""; }
    },
    drop(event) {
      try {
        this.lock = false
          // 기본 액션을 막음 (링크 열기같은 것들)
          event.preventDefault();
          // 드래그한 요소를 드롭 대상으로 이동
          if (_.startsWith(event.target.className, 'dropzone_path')) {

            if(event.target.className == "dropzone_path_scan_list") {
              this.$parent.$emit("add_scan_list", this.dragged)
              // console.log(event.target)
            }

            if(!this.scan_list.length) {
              return this.$toastr.w('warning', 'no have monitoring folder')
            }

            if(event.target.className == "dropzone_path_white_list") {

              console.log(this.scan_list, this.dragged)

              if(_.filter(this.scan_list, x => _.startsWith(this.dragged.abs_path, x)).length < 1 ) {
                // if(_.filter(this.scan_list, x => !_.startsWith(x, this.input_custom_1) == false).length > 0) {
                // 해당 경로는 넣을 수 없음
                return this.$toastr.w('warning', 'Monitoring folder not included #path-drop')
              }

              this.$parent.$emit("add_white_list", this.dragged)
            }

            if(event.target.className == "dropzone_path_white_list_file") {

              if(_.filter(this.scan_list, x => _.startsWith(this.dragged.abs_path, x)).length < 1 ) {
                console.log(this.scan_list, this.dragged)
                // if(_.filter(this.scan_list, x => !_.startsWith(x, this.input_custom_1) == false).length > 0) {
                // 해당 경로는 넣을 수 없음
                return this.$toastr.w('warning', 'Monitoring folder not included #file-drop')
              }

              this.$parent.$emit("add_white_list_file", this.dragged)
            }
            // 해당 경로 변수에 데이터 넣기
            event.target.style.background = "";

            // console.log('this.dragged', this.dragged)
          }

          // TODO : 하나 입력 폼으로 드래그할 경우 값 세팅
          if (_.startsWith(event.target.className, 'white_path_one')) {
            if(event.target.className == "white_path_one") {
              this.$parent.$emit("white_path_one", this.dragged)
              // console.log(event.target)
            }

            // 해당 경로 변수에 데이터 넣기
            event.target.style.background = "";

            // console.log('this.dragged', this.dragged)
          }



        } catch (e) {
          console.log(e)
        }
    },
    get_path(c) {
      try {
        if(!c || !c.abs_path || !c.count || c.child.length) { return console.log('no have folder'); }
        this.$parent.$emit('path', c.abs_path);
        this.$parent.$emit('rr', c);
      } catch (e) {
        console.log(e)
      }
    },
    refresh() {
      this.$parent.$emit('path', '');
      this.$toastr.i("path refresh")
      // this.$parent.$emit('rr', );
    }

  },
  created: function() {   console.log('folderSet.vue', 'created'); },
  destroyed: function() { console.log('folderSet.vue', 'destroyed'); },
  mounted: function() { console.log('folderSet.vue', 'mounted'); }

}
